export const ALT = "Alt";
export const ARROW_DOWN = "ArrowDown";
export const ARROW_LEFT = "ArrowLeft";
export const ARROW_RIGHT = "ArrowRight";
export const ARROW_UP = "ArrowUp";
export const BACKSPACE = "Backspace";
export const CAPS_LOCK = "CapsLock";
export const CONTROL = "Control";
export const DELETE = "Delete";
export const END = "End";
export const ENTER = "Enter";
export const ESCAPE = "Escape";
export const F1 = "F1";
export const F10 = "F10";
export const F11 = "F11";
export const F12 = "F12";
export const F2 = "F2";
export const F3 = "F3";
export const F4 = "F4";
export const F5 = "F5";
export const F6 = "F6";
export const F7 = "F7";
export const F8 = "F8";
export const F9 = "F9";
export const HOME = "Home";
export const META = "Meta";
export const PAGE_DOWN = "PageDown";
export const PAGE_UP = "PageUp";
export const SHIFT = "Shift";
export const SPACE = " ";
export const TAB = "Tab";
export const CTRL = "Control";
export const ASTERISK = "*";
export const a = "a";
export const P = "P";
export const A = "A";
export const p = "p";
export const n = "n";
export const j = "j";
export const k = "k";
